<template>
  <div>
    <v-select
      v-model="packingType"
      :items="packinTypesText"
      :label="$t('packing_type_select.default_packing_type')"
      :no-data-text="$t('packing_type_select.no_packing_types_found')"
      centre
      required
      solo
      @change="packingTypeSelected(packingType)"
    ></v-select>
  </div>
</template>

<script>
export default {
    props: ['packingTypes'],
    data(){
        return{
            packingType: {},
            packinTypesText: []
        }
    },
    mounted(){
        this.packinTypesText = getPackingTypesText(this.packingTypes);
    },

    methods: {
        packingTypeSelected(packingType){
            this.$emit('packingTypeSelected', packingType)
        }
    }
}

function getPackingTypesText(packingTypes){
    let packinTypesWithText = [];
    packingTypes.forEach(packingType => {
        packinTypesWithText.push({
            value: packingType.id,
            text: packingType.description
        });
    });
    return packinTypesWithText;
}
</script>
